module.exports = __webpack_public_path__ + "img/34-min.8c13b318.jpg";